import { isEnvFlagEnabled } from './is-env-flag-enabled';

export function isUnderTest() {
	return isEnvFlagEnabled(import.meta?.env?.TEST);
}
